import FormController from 'controllers/form-controller';
import { triggerCustomEvent } from 'lib/helpers';
import events from 'lib/events';

export default class LoginFormController extends FormController {
  connect() {
    if (this.element.getAttribute('data-from-collection') === 'true') {
      triggerCustomEvent(events.collections.login_popup, {});
    }

    super.connect();
  }

  validateFields() {
    super.validateFields();

    if (this.formValid) {
      this.submit();
    } else {
      super.hideSpinner();
    }
  }
}
